export default {
  common: {
    welcome: 'Selamat Datang',
    login: 'Log Masuk',
    logout: 'Log Keluar',
    register: 'Daftar',
    email: 'E-mel',
    password: 'Kata Laluan',
    confirmPassword: 'Sahkan Kata Laluan',
    submit: 'Hantar',
    cancel: 'Batal',
    save: 'Simpan',
    delete: 'Padam',
    edit: 'Edit',
    search: 'Cari',
    loading: 'Memuatkan...',
    error: 'Ralat',
    success: 'Berjaya',
    close: 'Tutup',
    back: 'Kembali',
    next: 'Seterusnya',
    previous: 'Sebelumnya',
    yes: 'Ya',
    no: 'Tidak',
    ok: 'OK',
  },
  auth: {
    signIn: 'Log Masuk',
    signUp: 'Daftar Akaun',
    signOut: 'Log Keluar',
    forgotPassword: 'Terlupa Kata Laluan?',
    resetPassword: 'Set Semula Kata Laluan',
    changePassword: 'Tukar Kata Laluan',
    emailAddress: 'Alamat E-mel',
    enterEmail: 'Masukkan e-mel anda',
    enterPassword: 'Masukkan kata laluan anda',
    rememberMe: 'Ingat saya',
    dontHaveAccount: 'Belum ada akaun?',
    alreadyHaveAccount: 'Sudah mempunyai akaun?',
    createAccount: 'Buat Akaun',
    passwordRequirements: 'Kata laluan mestilah sekurang-kurangnya 8 aksara',
    accountCreated: 'Akaun berjaya dibuat',
    loginSuccess: 'Berjaya log masuk',
    loginFailed: 'Log masuk gagal',
    invalidCredentials: 'E-mel atau kata laluan tidak sah',
    emailRequired: 'E-mel diperlukan',
    passwordRequired: 'Kata laluan diperlukan',
    passwordMismatch: 'Kata laluan tidak sepadan',
  },
  validation: {
    required: 'Medan ini diperlukan',
    invalidEmail: 'Alamat e-mel tidak sah',
    minLength: 'Mestilah sekurang-kurangnya {{count}} aksara',
    maxLength: 'Mestilah tidak lebih daripada {{count}} aksara',
    passwordTooShort: 'Kata laluan mestilah sekurang-kurangnya {{count}} aksara',
    passwordTooWeak: 'Kata laluan terlalu lemah',
    emailInUse: 'E-mel sudah digunakan',
    invalidFormat: 'Format tidak sah',
  },
  errors: {
    general: 'Sesuatu tidak kena. Sila cuba lagi.',
    network: 'Ralat rangkaian. Sila semak sambungan anda.',
    notFound: 'Sumber tidak dijumpai',
    unauthorized: 'Anda tidak diberi kuasa untuk melakukan tindakan ini',
    serverError: 'Ralat pelayan. Sila cuba lagi kemudian.',
    timeout: 'Tamat masa permintaan. Sila cuba lagi.',
  },
} as const
